export default "__VITE_ASSET__R9XkmXiu__"